import { c as _c } from "react/compiler-runtime";
import useChatMessageStore from '@module/stores/useChatMessageStore';
import { useFetchLivePlayMutationStore } from '@module/stores/useFetchLivePlayMutationStore';
import useOldPlayerStore from '@module/stores/useOldPlayerStore';
import { isNormalChatMessage } from '@module/types/centrifuge/public-message';
import { useEffect, useRef } from 'react';

// livePlusSwitchGuideMessage 미제공 시 폴백(모바일 상단 인트로와 동일 문구).
const FALLBACK_MESSAGE = '현재 방송은 실제 시차가 거의 없는 라이브+ 방송입니다.\nBJ와 소통 시 시차없는 실시간 반응을 경험해 보세요!';
const GUIDE_INTERVAL = 100;

/**
 * [PandaTV 전용] RT 전환 가능한 방송(hasRT)을 LL(일반)로 시청 중인 유저에게 라이브+ 전환을 유도하는
 * 안내(ChatIntro, variant 'll')를 채팅에 주입한다. 클라 전용 — 소켓 미전송, 본인에게만 보인다.
 *
 * - 사용자가 명시적으로 RT→LL 전환한 직후 1회.
 * - 이후 활성 구간에서 실채팅(isNormalChatMessage) 100개마다 1회, RT 복귀 전까지.
 * - 강제 폴백(isForcedLL)은 즉시·주기 모두 제외. 입장-이미-LL은 전환이 아니므로 즉시 주입만 제외(주기는 노출).
 */
function useRtLowLatencySwitchGuide() {
  const $ = _c(22);
  const {
    data: playInfo
  } = useFetchLivePlayMutationStore();
  const chatMessages = useChatMessageStore(_temp);
  const setChatMessages = useChatMessageStore(_temp2);
  const streamMode = useOldPlayerStore(_temp3);
  const isForcedLL = useOldPlayerStore(_temp4);
  const hasRT = !!playInfo?.PlayList?.whip?.[0]?.token;
  const message = playInfo?.chatMessage?.livePlusSwitchGuideMessage ?? FALLBACK_MESSAGE;
  const isActive = hasRT && streamMode === "LL" && !isForcedLL;
  const prevStreamModeRef = useRef(streamMode);
  const anchorRef = useRef(null);
  let t0;
  if ($[0] !== message || $[1] !== setChatMessages) {
    t0 = () => {
      setChatMessages(prev => [...prev, {
        data: {
          type: "ChatIntro",
          message,
          variant: "ll"
        },
        offset: Date.now()
      }]);
    };
    $[0] = message;
    $[1] = setChatMessages;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const injectGuide = t0;
  let t1;
  if ($[3] !== chatMessages) {
    t1 = () => chatMessages.length ? chatMessages[chatMessages.length - 1] : null;
    $[3] = chatMessages;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const tail = t1;
  const bjUserId = playInfo?.media?.userId;
  let t2;
  if ($[5] !== streamMode || $[6] !== tail) {
    t2 = () => {
      anchorRef.current = tail();
      prevStreamModeRef.current = streamMode;
    };
    $[5] = streamMode;
    $[6] = tail;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== bjUserId) {
    t3 = [bjUserId];
    $[8] = bjUserId;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useEffect(t2, t3);
  let t4;
  if ($[10] !== chatMessages || $[11] !== injectGuide || $[12] !== isActive || $[13] !== playInfo?.livePlusSwitchThreshold || $[14] !== streamMode || $[15] !== tail) {
    t4 = () => {
      const wasRT = prevStreamModeRef.current === "RT";
      prevStreamModeRef.current = streamMode;
      if (wasRT && isActive) {
        injectGuide();
        anchorRef.current = tail();
        return;
      }
      if (!isActive) {
        anchorRef.current = tail();
        return;
      }
      const livePlusSwitchThreshold = playInfo?.livePlusSwitchThreshold ?? GUIDE_INTERVAL;
      const anchorIdx = anchorRef.current ? chatMessages.lastIndexOf(anchorRef.current) : -1;
      const sinceAnchor = anchorIdx >= 0 ? chatMessages.slice(anchorIdx + 1) : chatMessages;
      if (sinceAnchor.filter(isNormalChatMessage).length >= livePlusSwitchThreshold) {
        injectGuide();
        anchorRef.current = tail();
      }
    };
    $[10] = chatMessages;
    $[11] = injectGuide;
    $[12] = isActive;
    $[13] = playInfo?.livePlusSwitchThreshold;
    $[14] = streamMode;
    $[15] = tail;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== chatMessages || $[18] !== hasRT || $[19] !== isForcedLL || $[20] !== streamMode) {
    t5 = [chatMessages, streamMode, isForcedLL, hasRT];
    $[17] = chatMessages;
    $[18] = hasRT;
    $[19] = isForcedLL;
    $[20] = streamMode;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  useEffect(t4, t5);
}
function _temp4(state_2) {
  return state_2.isForcedLL;
}
function _temp3(state_1) {
  return state_1.streamMode;
}
function _temp2(state_0) {
  return state_0.setChatMessages;
}
function _temp(state) {
  return state.chatMessages;
}
export default useRtLowLatencySwitchGuide;